"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryList = exports.queryList = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@reactionable/core");
var react_1 = require("react");
var Query_1 = require("./Query");
function queryList(options) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var items, tmpOptions, result, data, hasLimitVariable, limitNotReached, shouldFetchMore;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    items = [];
                    tmpOptions = Object.assign({}, options);
                    _b.label = 1;
                case 1:
                    if (!true) return [3 /*break*/, 3];
                    return [4 /*yield*/, Query_1.query(tslib_1.__assign(tslib_1.__assign({}, tmpOptions), { rawData: true }))];
                case 2:
                    result = _b.sent();
                    data = extractListData(result);
                    items.push.apply(items, tslib_1.__spread(data.items));
                    hasLimitVariable = !!((_a = options === null || options === void 0 ? void 0 : options.variables) === null || _a === void 0 ? void 0 : _a.limit);
                    limitNotReached = hasLimitVariable && items.length - 1 < options.variables.limit;
                    shouldFetchMore = data.nextToken && (tmpOptions.queryAll || limitNotReached);
                    if (!shouldFetchMore) {
                        return [2 /*return*/, tslib_1.__assign(tslib_1.__assign({}, data), { items: items })];
                    }
                    // Set next token variable
                    tmpOptions = Object.assign(tmpOptions, {
                        variables: tslib_1.__assign(tslib_1.__assign({}, tmpOptions.variables), { nextToken: data.nextToken }),
                    });
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.queryList = queryList;
exports.useQueryList = function (options) {
    var _a = tslib_1.__read(react_1.useState(), 2), currentToken = _a[0], setCurrentToken = _a[1];
    var _b = tslib_1.__read(react_1.useState(), 2), nextToken = _b[0], setNextToken = _b[1];
    var _c = tslib_1.__read(react_1.useState(), 2), previousToken = _c[0], setPreviousToken = _c[1];
    var _d = tslib_1.__read(react_1.useState([]), 2), list = _d[0], setList = _d[1];
    var _e = core_1.useQuery(tslib_1.__assign(tslib_1.__assign({}, options), { variables: tslib_1.__assign(tslib_1.__assign({}, options.variables), { nextToken: currentToken }), handleQuery: function (queryOptions) { return queryList(queryOptions); } })), refetch = _e.refetch, data = _e.data, result = tslib_1.__rest(_e, ["refetch", "data"]);
    var refetchList = function () {
        setList([]);
        refetch();
    };
    var next = function () {
        setPreviousToken(currentToken);
        setCurrentToken(nextToken);
    };
    var previous = function () { return setCurrentToken(previousToken); };
    react_1.useEffect(function () {
        setList(data ? data.items || [] : []);
        if (data) {
            setNextToken(data.nextToken);
        }
    }, [data]);
    return tslib_1.__assign(tslib_1.__assign({}, result), { data: list, refetch: refetchList, next: nextToken ? next : undefined, previous: currentToken ? previous : undefined });
};
function extractListData(result) {
    if (!result) {
        throw new Error('No data');
    }
    var data = result;
    while (data.items === undefined) {
        data = data[Object.keys(data)[0]];
        if (!data) {
            throw new Error('No data found in result');
        }
    }
    return data;
}
//# sourceMappingURL=QueryList.js.map